import { Injectable } from '@angular/core';
import * as i0 from "@angular/core";
const DEBUG_FLAGS_LOCAL_STORAGE_KEY = 'DEBUG_FLAGS_LOCAL_STORAGE_KEY';
export class DebugFlagsStorageService {
    constructor() { }
    saveToLocalStorage(settings) {
        try {
            localStorage.setItem(DEBUG_FLAGS_LOCAL_STORAGE_KEY, JSON.stringify(settings));
        }
        catch (error) {
            // ignore
            console.error('Error saving debug flags to local storage:', error);
        }
        return;
    }
    clearLocalStorage() {
        localStorage.removeItem(DEBUG_FLAGS_LOCAL_STORAGE_KEY);
    }
    getFromLocalStorage() {
        try {
            const settingsJson = localStorage.getItem(DEBUG_FLAGS_LOCAL_STORAGE_KEY);
            return settingsJson ? JSON.parse(settingsJson) : {};
        }
        catch (error) {
            // ignore
            console.error('Error retrieving debug flags from local storage:', error);
        }
        return {};
    }
    static { this.ɵfac = function DebugFlagsStorageService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DebugFlagsStorageService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DebugFlagsStorageService, factory: DebugFlagsStorageService.ɵfac }); }
}
//# sourceMappingURL=debug-flags-storage.service.js.map